import { ChangeDetectorRef, Component, OnChanges, OnInit } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { BookingService } from '@shared/services/booking.service';

@Component({
  selector: 'app-toolbar-services',
  templateUrl: './toolbar-services.component.html',
  styleUrls: ['./toolbar-services.component.scss']
})
export class ToolbarServicesComponent implements OnInit{

  public serviceData: any[] = [];
  public services: any [] = [];
  public toolbarServiceItem: any[] = [];
  public isActive: boolean = false;
  public selectedActivity: string | null = null;

 constructor(
  private bookingService: BookingService,
  private cdr: ChangeDetectorRef,
  private apiService: ApiService)
  {}

ngOnInit(): void {
  this.apiService.getServicesList().subscribe((response: any) => {
    this.serviceData = response;
    this.services = this.serviceData.filter((service: any) => service.name);
    this.toolbarServiceItem =this.serviceData.map((service:any) => {
      return {
        icon: `assets/icons/icon_${service.icon}.png`,
        msg: service.msg,
        route: `/panel/bookings/add-booking/${service.id}`,
        truncate: true
      }
    })
  })

  this.bookingService.selectedActivity$.subscribe(selectedActivity => {
    this.selectedActivity = selectedActivity[0] || null;
  });

}

getActivity(msg: string | null | undefined): void {
  if (msg) {
      this.isActive = true;
      this.bookingService.updateSelectedActivity([msg]);
    }
  }

  getStyleIcon() {

  }

}
